import api from './api';

// Document signing happens on the backend (see POST /api/sign-document in
// server.js) — the signing secret must never be shipped to the browser.
// This is a thin client for that endpoint, kept as a class for drop-in
// compatibility with existing call sites.
export class DocumentSecurity {

  // Ask the backend to sign a document and return { signature, verificationUrl, qrCodeDataUrl }.
  // documentData: { studentId, semester, timestamp?, modules?/registrations?/subjects? }
  static async signDocument(documentData) {
    return DocumentSecurity._sign('/sign-document', documentData);
  }

  // Same as signDocument, but sent through an /admin/ path so the axios
  // interceptor in services/api.js attaches the admin token instead of the
  // student token (see api.js's request interceptor).
  static async signDocumentAsAdmin(documentData) {
    return DocumentSecurity._sign('/admin/sign-document', documentData);
  }

  static async _sign(path, documentData) {
    try {
      const response = await api.post(path, { documentData });
      return response.data; // { signature, verificationUrl, qrCodeDataUrl }
    } catch (error) {
      console.error('Error signing document:', error);
      return { signature: null, verificationUrl: null, qrCodeDataUrl: null };
    }
  }
}
